import axios, { AxiosResponse } from 'axios'
import { PopulationParam } from 'common/constants/PopulationParam'
import { LayoutPromiseType } from 'common/types/LayoutPromiseType'
import Env from 'Env'
import HTTPMethod from 'http-method-enum'
import { AppInfoModel } from 'models/config/AppInfoModel'
import { Converters } from './Converters'

class LayoutPromiseClass implements LayoutPromiseType {
  constructor() {}

  async AppConfig() {
    return await axios({
      method: HTTPMethod.GET,
      baseURL: Env.ApiUrl,
      url: '/app-info',
      params: PopulationParam,
    }).then((resp) => this._convertCase(resp.data))
  }

  async Posters() {
    return axios({
      method: 'GET',
      baseURL: Env.ApiUrl,
      url: '/posters',
    })
  }
  async MainMenu() {
    const appConfig = await this._getAppConfig()
    const mainMenuSlug = await this._getMainMenuSlug(appConfig)
    const menuId = await this._getMenuIdFromSlug(mainMenuSlug)

    return this._getMenuById(menuId)
  }

  async FooterMenu() {
    const appConfig = await this._getAppConfig()
    const footerSlug = this._getFooterMenuSlug(appConfig)
    const footerMenuId = await this._getMenuIdFromSlug(footerSlug)

    return this._getMenuById(footerMenuId)
  }

  GetMainAndFooterMenu() {
    return [this.MainMenu(), this.FooterMenu(), this.Posters()]
  }

  // Private Methods
  private async _getAppConfig(): Promise<AppInfoModel> {
    return await axios({
      method: HTTPMethod.GET,
      baseURL: Env.ApiUrl,
      url: '/app-info',
      params: PopulationParam,
    }).then((resp) => this._convertCase(resp.data))
  }

  private async _getMenuById(id: number): Promise<AxiosResponse> {
    return axios({
      method: HTTPMethod.GET,
      baseURL: Env.ApiUrl,
      url: `/menus/${id}`,
      params: PopulationParam,
    })
  }

  private async _getMenuIdFromSlug(slug: string): Promise<number> {
    return axios({
      method: HTTPMethod.GET,
      baseURL: Env.ApiUrl,
      url: `/menus?filters[Slug][$eq]=${slug}`,
    }).then((resp) => resp.data['data'][0]['id'])
  }

  private _convertCase<T extends object>(input: T) {
    return Converters.KeysConvert.ToLowerCase(input)
  }

  private _getMainMenuSlug(config: AppInfoModel) {
    return config.data.attributes.mainMenuSlug
  }

  private _getFooterMenuSlug(config: AppInfoModel) {
    return config.data.attributes.footerSlug
  }
}

export const LayoutPromise = new LayoutPromiseClass()
